import * as util from '#packages/util';
import type { AddElementsPanelOptions } from '@wix/platform-editor-sdk';
import type { EditorAPI } from '#packages/editorAPI';

function getLinkAsString(
  editorAPI: EditorAPI,
  _appData: any,
  _token: string,
  options: { link: { type: string } },
) {
  return util.link.getLinkValueAsString(editorAPI, options.link);
}

function getCsrfToken(): string {
  return util.cookie.getCookie('XSRF-TOKEN');
}

const getElementsPanelPropsFromOptions = (
  options: AddElementsPanelOptions,
) => ({
  helpId: options.helpId,
  widgetRef: options.widgetRef,
  elementsData: options.elementsData,
  categoriesData: options.categoriesData,
  sectionsData: options.sectionsData,
  withDivider: options.withDivider,
  subtitle: options.subtitle,
  topBanner: options.topBanner,
  type: 'add',
});

export { getLinkAsString, getCsrfToken, getElementsPanelPropsFromOptions };
